<gl-pro-modal (closeModal)="close()">
  @if (currentLang==='pl') {
    <div class="plContentContainer">
      <p>Dzień Dobry, <br />
        w tym roku wdrożyliśmy niemal 100 usprawnień i nowych funkcji.
      </p>
      <p><strong>Wśród nowości znalazły się:</strong>
      <p>
        <ul>
          <li>- piętrowanie ładunku większego na mniejszym</li>
          <li>- usprawniony algorytm obliczający optymalne rozmieszczenie załadunków</li>
          <li>- poprawienie wyświetlania nazw na ładunkach</li>
          <li>- usprawnienie ręcznego przenoszenia ładunków w pojazdach z chłodnią i nadkolami</li>
          <li>- łatwe przejście do głównej wizualizacji poprzez kliknięcie na małą wizualizację podczas dodawania ładunku
          </li>
          <li>- usprawnienie dodawania ładunków z pliku CSV, zapobiegające ich obracaniu się, gdy są oznaczone jako
            nieobracalne
          </li>
        </ul>
        <p><strong>Obecnie pracujemy nad:</strong></p>
        <ul>
          <li>- poprawieniem sposobu układania rur i beczek</li>
          <li>- ulepszeniem sposobu działania rekomendacji</li>
          <li>- usprawnieniem sposobu pracy z paletami</li>
          <li>- zapisywaniem ustawień dotyczących piętrowania i obracania ładunków</li>
        </ul>
        <p>
          Jeśli chcesz byśmy poprawili albo dodali nową funkcję <a pro-link href="https://www.goodloading.com/pl/kontakt/">napisz
        do nas</a>
      </p>
    </div>
  }
  @if (currentLang!=='pl') {
    <div class="enContentContainer">
      <p>Good morning, <br>
        <p>this year, we implemented almost 100 improvements and new functions.</p>
        <p>The new items include:</p>
        <ul>
          <li>- stacking a larger load on a smaller one
            <li>- improved algorithm calculating optimal load arrangement
              <li>- improved display of names on loads
                <li>- improved manual handling of loads in refrigerated vehicles and wheel arches
                  <li>- easy access to the main visualization by clicking on the small visualization when adding a load
                    <li>- improved adding loads from a CSV file, preventing them from rotating when marked as non-rotatable
                    </ul>
                    <p>
                    We are currently working on:</p>
                    <ul>
                      <li>- improving the way of laying pipes and barrels
                        <li>- improving the way recommendations work
                          <li>- improvement of the way of working with pallets
                            <li>- saving settings for stacking and rotating loads
                            </ul>
                            <p>
                              If you want us to improve or add a new feature, please <a pro-link href="https://www.goodloading.com/en/contact/"
                              target="_blank">write to
                            us</a></p>
                          </div>
                        }
                        <p>

                        </p>
                      </gl-pro-modal>
